import type { ContactHasVBOWaardecheckReportEventFilter } from './types.flow';
import type { Node_NodeContainer_Leaf_Activity_Event_Contact__Input } from '~/graphql/types';

import asHasFilterInput from '../../Primitive/Has/asHasFilterInput';

const asHasVBOWaardecheckReportEventFilterInput = (
  filter: ContactHasVBOWaardecheckReportEventFilter,
): Node_NodeContainer_Leaf_Activity_Event_Contact__Input | null => ({
  App: {
    VBOWaardecheck: {
      Report: {
        has: asHasFilterInput(filter.has),
      },
    },
  },
});

export default asHasVBOWaardecheckReportEventFilterInput;
